import { connect } from "react-redux";
import IFrame from "../iFrame/iFrame.component.jsx";
import React from "react";
import * as mainAction from "../../../reduxStore/actions/main.js";
import { AppOverlay } from "../../../functions/classes/miscelleanous.classes.js";
import Search from "../../search/search.jsx";
import SplashScreen from "../splashScreen/splashScreen.render.jsx";
import IdleOverlay from "../idleOverlay/idleOverlay.component.jsx";
import { terminalHandAnimation } from "../../../app/app.sideEffects/useURLParams.sideEffects.js";

/**
 * Hier kommen alle main MapUIOverlays rein. Also Screens, die über eine Page eingeblendet werden.
 * Hier kann man zentral auch eine Anzeige Hierarchie (falls mehere angezeigt werden) machen.
 * @param showCreateAppointment
 * @param {AppOverlay, AppOverlaySearch, AppOverlayIFrame} currentAppOverlay
 * @return {JSX.Element|null}
 * @constructor
 */
function AppOverlays({
  currentAppOverlay,
  setCurrentAppOverlay,
  isApp,
  isTerminal,
  terminalIsIdle,
}) {
  if (!currentAppOverlay.show) return null;

  switch (currentAppOverlay.name) {
    case AppOverlay.names.customContent:
      return (
        <SplashScreen
          onClosingFinished={setCurrentAppOverlay}
          render={(handleClose) => currentAppOverlay.value(handleClose)}
        />
      );

    case AppOverlay.names.iFrame: {
      return (
        <IFrame
          url={currentAppOverlay.value.url}
          title={currentAppOverlay.value.title}
          event={currentAppOverlay.event}
          contentType={currentAppOverlay.contentType}
          onClose={() => setCurrentAppOverlay(new AppOverlay())}
          isTerminal={isTerminal}
          isApp={isApp}
        />
      );
    }

    case AppOverlay.names.search:
      return (
        <SplashScreen
          onClosingFinished={currentAppOverlay.onClose}
          render={(handleClose) => (
            <Search
              type={currentAppOverlay.type}
              onClose={handleClose}
              mustHaveLocation={currentAppOverlay.mustHaveLocation}
              onPOIClicked={currentAppOverlay.onPOIClicked}
              canSetCurrentPosition={currentAppOverlay.canSetCurrentPosition}
              canSetPositionOnMap={currentAppOverlay.canSetPositionOnMap}
              onSpecialLocationClicked={
                currentAppOverlay.onSpecialLocationClicked
              }
            />
          )}
        />
      );
    default:
      // wenn im Terminal Mode und der Terminal is Idle -> Hand Gestures!
      if (isTerminal && terminalIsIdle && terminalHandAnimation) {
        return <IdleOverlay />;
      } else {
        return null;
      }
  }
}

const mapPropsToState = (state) => ({
  currentAppOverlay: state.main.currentAppOverlay,
  isApp: state.main.isApp,
  terminalIsIdle: state.main.terminalIsIdle,
  isTerminal: state.main.isTerminal,
});
const mapDispatchToState = (dispatch) => ({
  setCurrentAppOverlay: (appOverlay) =>
    dispatch(mainAction.setCurrentAppOverlay(appOverlay)),
});

export default connect(mapPropsToState, mapDispatchToState)(AppOverlays);
